import { ausrehabApi as baseApi } from '../baseApi';
import type { UserProps, RoleProps } from '../../models';

export const userApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		syncNewUser: builder.mutation<void, void>({
			query: () => {
				return {
					url: '/auth/postLogin',
					method: 'POST',
				};
			},
		}),

		getUsers: builder.query<UserProps[], void>({
			query: () => ({
				url: 'users/all',
			}),
			providesTags: ['Users'],
		}),

		getUser: builder.query({
			query: (id) => ({
				url: `users/${id}`,
			}),
			providesTags: ['Users'],
		}),

		getUserByEmail: builder.query({
			query: (email) => ({
				url: `users?email=${encodeURIComponent(email)}`,
			}),
			providesTags: ['Users'],
		}),

		updateUser: builder.mutation({
			query: (payload) => {
				return {
					url: `users/${payload.id}`,
					method: 'PUT',
					body: payload,
				};
			},
			invalidatesTags: ['Users'],
		}),

		getRoles: builder.query<RoleProps[], void>({
			query: () => ({
				url: 'roles',
			}),
		}),
	}),
	overrideExisting: false,
});

// retrieve user object from earlier query cached result
// this is good when we need to derive new data from existing state
export const selectUserByEmailResult = (email: string) => userApi.endpoints.getUserByEmail.select(email);

export const {
	useGetUsersQuery,
	useGetUserQuery,
	useGetRolesQuery,
	useGetUserByEmailQuery,

	// mutations
	useSyncNewUserMutation,
	useUpdateUserMutation,
} = userApi;
